import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function PieIcon({ className, size = 20, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        d="M14 10V3.28C14 3.12536 14.1254 3 14.28 3C17.9914 3 21 6.00865 21 9.72C21 9.87464 20.8746 10 20.72 10H14Z"
        fill="currentColor"
      />
      <path
        d="M20.9445 12.998C21.0057 12.4491 20.5523 12 20 12H13C12.4477 12 12 11.5523 12 11V4C12 3.44772 11.5509 2.99425 11.002 3.05549C9.57508 3.2147 8.20174 3.71371 6.99987 4.51677C5.51983 5.50571 4.36628 6.91131 3.68509 8.55585C3.0039 10.2004 2.82567 12.01 3.17294 13.7558C3.5202 15.5016 4.37737 17.1053 5.63604 18.364C6.89472 19.6226 8.49836 20.4798 10.2442 20.8271C11.99 21.1743 13.7996 20.9961 15.4442 20.3149C17.0887 19.6337 18.4943 18.4802 19.4832 17.0001C20.2863 15.7983 20.7853 14.4249 20.9445 12.998Z"
        fill="currentColor"
      />
    </svg>
  )
}
